import React from 'react';
import {
  BarChartOutlined,
  DatabaseOutlined,
  ExperimentOutlined,
  GlobalOutlined,
  LaptopOutlined,
  LinkOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import LabImpact from '../Shared/LabImpact';

const metrics = [
  { value: 23, label: 'Academic Research & Development', icon: ExperimentOutlined },
  { value: 3, label: 'Hardware/ Software', icon: LaptopOutlined },
  { value: 0, label: 'Data & Inventory Management', icon: DatabaseOutlined },
  { value: 71, label: 'Models & Maps Development', icon: GlobalOutlined },
  { value: 39, label: 'Capacity Building', icon: TeamOutlined },
  { value: 17, label: 'Linkages & Commercialization', icon: LinkOutlined },
  { value: 59, label: 'Research Impact', icon: BarChartOutlined },
];

const Impact = () => <LabImpact labName="SARL" metrics={metrics} />;

export default Impact;
